'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('shared/modules/App/types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import htmlEntities from 'html-entities';

var initialState = {
  title: '',
  tagline: '',
  defaultIcon: '',
  icon: '',
  iconAlt: '',
  subsectorTitle: '',
  subsectorSubtitle: '',
  footer: {
    links: {
      training: [],
      employers: [],
      about: []
    },
    inspiringMessages: [],
    infographics: [],
    copyright: [],
    careerCategories: {
      title: '',
      categories: []
    }
  },
  navigation: [],
  head: [],

  tutorialOn: false,
  tutorial: {}
};

// const entities = new (htmlEntities.AllHtmlEntities)();
var entities = require('html-entities').XmlEntities;

var translateLabel = function translateLabel(label) {
  return entities.decode(label);
};

var translateNav = function translateNav(navigation) {
  return navigation.map(function (nav) {
    return {
      //id: '',
      label: translateLabel(nav.title),
      altTitle: nav.altTitle,
      href: nav.href
    };
  });
};

var translateFooterColumn = function translateFooterColumn(nav) {
  return {
    id: nav.id,
    title: nav.title,
    href: nav.href,
    links: nav.links.map(function (n) {
      return {
        id: n.id,
        label: n.title,
        href: n.href
      };
    })
  };
};

var translateCareerCategories = function translateCareerCategories(careerCategories) {
  return {
    title: careerCategories.title,
    categories: careerCategories.categories.map(function (category) {
      return {
        href: category.href,
        icon: category.icon,
        jobs: category.jobs,
        label: translateLabel(category.title)
      };
    })
  };
};

var translateInspiringMessages = function translateInspiringMessages(inspiringMessages) {
  return inspiringMessages.map(function (_ref) {
    var title = _ref.title,
        icon = _ref.icon,
        iconAlt = _ref.iconAlt,
        message = _ref.message,
        hrefTitle = _ref.hrefTitle,
        href = _ref.href;

    return {
      title: title,
      icon: icon,
      iconAlt: iconAlt,
      content: message,
      link: {
        href: href,
        label: hrefTitle
      }
    };
  });
};

var translateInfographics = function translateInfographics(infographicStats) {
  var _infographicStats$ = infographicStats[0],
      firstSlotTitle = _infographicStats$.firstSlotTitle,
      firstSlotContent = _infographicStats$.firstSlotContent,
      secondSlotTitle = _infographicStats$.secondSlotTitle,
      secondSlotContent = _infographicStats$.secondSlotContent,
      thirdSlotTitle = _infographicStats$.thirdSlotTitle,
      thirdSlotContent = _infographicStats$.thirdSlotContent;


  return [{
    title: firstSlotTitle,
    label: firstSlotContent
  }, {
    title: secondSlotTitle,
    label: secondSlotContent
  }, {
    title: thirdSlotTitle,
    label: thirdSlotContent
  }];
};

var translateGetApp = function translateGetApp(global) {
  return {
    title: global.name,
    headerHeadline: global.headerHeadline,
    headerTagline: global.headerTagline,
    headerTagline2: global.headerTagline2,
    tagline: global.tagline,
    defaultIcon: global.defaultIcon,
    icon: global.icon,
    iconAlt: global.iconAlt,
    subsectorTitle: global.subsectorTitle, // Sub-Sector
    subsectorSubtitle: global.subsectorSubtitle, // Sub-Sector
    footer: {
      links: {
        training: translateFooterColumn(global.footer[0].leftNavigation[0]),
        employers: translateFooterColumn(global.footer[0].rightNavigation[0]),
        about: translateFooterColumn(global.footer[0].middleNavigation[0])
      },
      inspiringMessages: translateInspiringMessages(global.inspiringMessages || []),
      infographics: translateInfographics(global.infographicStats || []),
      copyright: global.footer[0].copyrightNavigation.map(function (nav) {
        return {
          label: translateLabel(nav.title),
          href: nav.href
        };
      }),
      careerCategories: translateCareerCategories(global.footerCategories[0])
    },
    navigation: translateNav(global.primaryNavigation),
    head: global.head,
    tutorial: global.tutorial
  };
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types.GET_APP, {
  FULFILLED: function FULFILLED(state, _ref2) {
    var response = _ref2.response;

    return (0, _extends3.default)({}, state, translateGetApp(response, state));
  },
  REJECTED: function REJECTED(state, action) {
    if (action.error && action.error.message.indexOf('Invalid JSON from') !== -1) {
      return (0, _extends3.default)({}, state, {
        title: action.error.message,
        logo: ''
      });
    }

    return (0, _extends3.default)({}, state, {
      title: 'Unknown error',
      logo: ''
    });
  }
}), (0, _defineProperty3.default)(_typeToReducer, _types.TOGGLE_TUTORIAL, function (state) {
  return (0, _extends3.default)({}, state, {
    tutorialOn: !state.tutorialOn
  });
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/site/index.js
// module id = 1292
// module chunks = 0